export const LinkedinIcon = ({ ...props }) => (
   <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
   >
      <path
         d="M12.5377 0.5H1.45977C0.929102 0.5 0.5 0.918945 0.5 1.43691V12.5605C0.5 13.0785 0.929102 13.5 1.45977 13.5H12.5377C13.0684 13.5 13.5 13.0785 13.5 12.5631V1.43691C13.5 0.918945 13.0684 0.5 12.5377 0.5ZM4.35684 11.5779H2.42715V5.37246H4.35684V11.5779ZM3.39199 4.52695C2.77246 4.52695 2.27227 4.02676 2.27227 3.40977C2.27227 2.79277 2.77246 2.29258 3.39199 2.29258C4.00898 2.29258 4.50918 2.79277 4.50918 3.40977C4.50918 4.02422 4.00898 4.52695 3.39199 4.52695ZM11.5779 11.5779H9.65078V8.56152C9.65078 7.84297 9.63809 6.91621 8.64785 6.91621C7.64492 6.91621 7.49258 7.70078 7.49258 8.51074V11.5779H5.56797V5.37246H7.41641V6.22051H7.4418C7.69824 5.73301 8.32793 5.21758 9.26484 5.21758C11.2174 5.21758 11.5779 6.50234 11.5779 8.17305V11.5779V11.5779Z"
         fill="#1E3455"
      />
   </svg>
);
